import { Box, Typography } from "@mui/material";
import React from "react";
import { TextArea } from "../ui/form";
import Client from "./client";
import { tokens } from "../../theme";

const MAX_LENGTH = 1000;

/**
 * Paso 1: cliente y descripción del trabajo.
 * En escritorio van lado a lado; en teléfono, uno debajo del otro.
 */
const WorkDescription = ({ formState, setFormState, isOrderClosed, isReadOnlyMode }) => {
  const disabled = isOrderClosed || isReadOnlyMode;
  const length = (formState.description || "").length;

  return (
    <Box
      className="step_container"
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        width: "100%",
        minWidth: 0,
      }}
    >
      <Client
        showIcon={!isOrderClosed && !isReadOnlyMode}
        formState={formState}
        setFormState={setFormState}
        isReadOnlyMode={isReadOnlyMode}
      />

      <Box sx={{ display: "flex", flexDirection: "column", gap: "8px", flexGrow: 1, minHeight: 0 }}>
        <Box sx={{ display: "flex", alignItems: "baseline", gap: "8px" }}>
          <Typography sx={{ fontSize: "13px", fontWeight: 600, flexGrow: 1 }}>
            Descripción del trabajo
          </Typography>
          <Typography
            sx={{
              fontSize: "11.5px",
              fontVariantNumeric: "tabular-nums",
              color: length > MAX_LENGTH ? tokens.brandDark : tokens.ink3,
            }}
          >
            {length} / {MAX_LENGTH}
          </Typography>
        </Box>

        {/* Mismo campo que el resto del sistema: idéntico borde, foco y radio. */}
        <TextArea
          value={formState.description || ""}
          aria-label="Descripción del trabajo"
          placeholder="Qué se hizo, con qué materiales y cuánto llevó."
          rows={8}
          disabled={disabled}
          onChange={(e) => {
            if (!isReadOnlyMode) {
              setFormState({ ...formState, description: e.target.value });
            }
          }}
          sx={{ minHeight: { xs: 160, md: 220 }, flexGrow: 1 }}
        />
      </Box>
    </Box>
  );
};

export default WorkDescription;
